/**
 * Global Search API Client
 */

import { getHttpClient } from '@spcc/core'
import type { SearchResponse, PortalType } from '../../domain/types'
import { GLOBAL_SEARCH_ENDPOINTS, validateSearchResponse } from '../../api/api-types'

export interface SearchParams {
  query: string
  portal?: PortalType
  limit?: number
}

export const globalSearchApi = {
  async search(params: SearchParams): Promise<SearchResponse> {
    const http = getHttpClient()

    const searchParams = new URLSearchParams()
    searchParams.set('q', params.query)
    if (params.portal) {
      searchParams.set('portal', params.portal)
    }
    if (params.limit) {
      searchParams.set('limit', String(params.limit))
    }

    const response = await http.get<unknown>(
      `${GLOBAL_SEARCH_ENDPOINTS.SEARCH}?${searchParams}`
    )

    const data = (response.data as { data?: unknown })?.data
    return validateSearchResponse(data)
  },
}
